import {Wrapper} from "./shoppingCart.style";
import {Outlet} from "react-router";
import {NavbarSection} from "./subpages/shoppingCart/section/navbar";

export const CartPage = () => {
    return (
        <Wrapper>
            <NavbarSection/>
            <Outlet/>
        </Wrapper>
    )
}